import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from './Icon';

interface Header2Props {
  title: string;
}

const Header2 = ({ title }: Header2Props) => {
  const navigate = useNavigate();

  return (
    <>
      <Header>
        <button onClick={() => navigate(-1)} className="img-box">
          <Icon name="ArrowLeftIcon" size="100%" color="#6B7684" />
        </button>
        <h1>{title}</h1>
      </Header>
    </>
  );
};

export default Header2;

const Header = styled.header`
  width: 100%;
  height: 54px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
  position: relative;

  > button {
    width: 32px;
    position: absolute;
    left: 4px;
    top: 50%;
    transform: translateY(-50%);
  }

  > h1 {
    font-size: 16px;
    color: #000;
    font-weight: 600;
  }
`;
